import { AppConfig } from './types';

/**
 * Development environment configuration
 * Only specify values that differ from the default configuration
 */
export const stageConfig: Partial<AppConfig> = {
  proctoring: {
    api: {
      baseUrl: 'https://api.stage.smarterproctoring.com',
      timeout: 30000,
      retryAttempts: 3
    },
    ui : {
      baseUrl: 'https://app.stage.smarterservices.com',
    }
  },
  assessment: {
    api: {
      baseUrl: '',
      timeout: 30000,
      retryAttempts: 3
    }
  },
  core : {
    api: {
      baseUrl: 'https://signon.stage.smarterproctoring.com',
      timeout: 30000,
      retryAttempts: 3
    }
  },
  media : {
    api: {
      baseUrl: 'https://playback.stage.proctoring.media',
      timeout: 30000,
      retryAttempts: 3
    },
    playback: {
      baseUrl: 'https://playback.stage.proctoring.media',
    },    
    livekit: {
      websocketUrl: 'wss://media-stage-nyc1.proctoring.media',
    }
  },
  elements: {
    ui : {
      baseUrl: 'https://app.stage.smarterservices.com',
    }
  },
  logging: {
    logLevel: 'warn',
    logDestination: 'remote',
  }
};
